window.gifenc=(function(){var module={exports:{}};var exports=module.exports;
var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {get: all[name], enumerable: true});
};

// src/index.js
__markAsModule(exports);
__export(exports, {
  GIFEncoder: () => GIFEncoder,
  applyPalette: () => applyPalette,
  default: () => src_default,
  nearestColor: () => nearestColor,
  nearestColorIndex: () => nearestColorIndex,
  nearestColorIndexWithDistance: () => nearestColorIndexWithDistance,
  prequantize: () => prequantize,
  quantize: () => quantize,
  snapColorsToPalette: () => snapColorsToPalette
});

// src/constants.js
var constants_default = {
  signature: "GIF",
  version: "89a",
  trailer: 59,
  extensionIntroducer: 33,
  applicationExtensionLabel: 255,
  graphicControlExtensionLabel: 249,
  imageSeparator: 44,
  signatureSize: 3,
  versionSize: 3,
  globalColorTableFlagMask: 128,
  colorResolutionMask: 112,
  sortFlagMask: 8,
  globalColorTableSizeMask: 7,
  applicationIdentifierSize: 8,
  applicationAuthCodeSize: 3,
  disposalMethodMask: 28,
  userInputFlagMask: 2,
  transparentColorFlagMask: 1,
  localColorTableFlagMask: 128,
  interlaceFlagMask: 64,
  idSortFlagMask: 32,
  localColorTableSizeMask: 7
};

// src/stream.js
function createStream(initialCapacity = 256) {
  let cursor = 0;
  let contents = new Uint8Array(initialCapacity);
  return {
    get buffer() {
      return contents.buffer;
    },
    reset() {
      cursor = 0;
    },
    bytesView() {
      return contents.subarray(0, cursor);
    },
    bytes() {
      return contents.slice(0, cursor);
    },
    writeByte(byte) {
      expand(cursor + 1);
      contents[cursor] = byte;
      cursor++;
    },
    writeBytes(data, offset = 0, byteLength = data.length) {
      expand(cursor + byteLength);
      for (let i = 0; i < byteLength; i++) {
        contents[cursor++] = data[i + offset];
      }
    },
    writeBytesView(data, offset = 0, byteLength = data.byteLength) {
      expand(cursor + byteLength);
      contents.set(data.subarray(offset, offset + byteLength), cursor);
      cursor += byteLength;
    }
  };
  function expand(newCapacity) {
    var prevCapacity = contents.length;
    if (prevCapacity >= newCapacity)
      return;
    var CAPACITY_DOUBLING_MAX = 1024 * 1024;
    newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
    if (prevCapacity != 0)
      newCapacity = Math.max(newCapacity, 256);
    const oldContents = contents;
    contents = new Uint8Array(newCapacity);
    if (cursor > 0)
      contents.set(oldContents.subarray(0, cursor), 0);
  }
}

// src/lzwEncode.js
var BITS = 12;
var DEFAULT_HSIZE = 5003;
var MASKS = [
  0,
  1,
  3,
  7,
  15,
  31,
  63,
  127,
  255,
  511,
  1023,
  2047,
  4095,
  8191,
  16383,
  32767,
  65535
];
function lzwEncode(width, height, pixels, colorDepth, outStream = createStream(512), accum = new Uint8Array(256), htab = new Int32Array(DEFAULT_HSIZE), codetab = new Int32Array(DEFAULT_HSIZE)) {
  const hsize = htab.length;
  const initCodeSize = Math.max(2, colorDepth);
  accum.fill(0);
  codetab.fill(0);
  htab.fill(-1);
  let cur_accum = 0;
  let cur_bits = 0;
  const init_bits = initCodeSize + 1;
  const g_init_bits = init_bits;
  let clear_flg = false;
  let n_bits = g_init_bits;
  let maxcode = (1 << n_bits) - 1;
  const ClearCode = 1 << init_bits - 1;
  const EOFCode = ClearCode + 1;
  let free_ent = ClearCode + 2;
  let a_count = 0;
  let ent = pixels[0];
  let hshift = 0;
  for (let fcode = hsize; fcode < 65536; fcode *= 2) {
    ++hshift;
  }
  hshift = 8 - hshift;
  outStream.writeByte(initCodeSize);
  output(ClearCode);
  const length = pixels.length;
  for (let idx = 1; idx < length; idx++) {
    next_block: {
      const c = pixels[idx];
      const fcode = (c << BITS) + ent;
      let i = c << hshift ^ ent;
      if (htab[i] === fcode) {
        ent = codetab[i];
        break next_block;
      }
      const disp = i === 0 ? 1 : hsize - i;
      while (htab[i] >= 0) {
        i -= disp;
        if (i < 0)
          i += hsize;
        if (htab[i] === fcode) {
          ent = codetab[i];
          break next_block;
        }
      }
      output(ent);
      ent = c;
      if (free_ent < 1 << BITS) {
        codetab[i] = free_ent++;
        htab[i] = fcode;
      } else {
        htab.fill(-1);
        free_ent = ClearCode + 2;
        clear_flg = true;
        output(ClearCode);
      }
    }
  }
  output(ent);
  output(EOFCode);
  outStream.writeByte(0);
  return outStream.bytesView();
  function output(code) {
    cur_accum &= MASKS[cur_bits];
    if (cur_bits > 0)
      cur_accum |= code << cur_bits;
    else
      cur_accum = code;
    cur_bits += n_bits;
    while (cur_bits >= 8) {
      accum[a_count++] = cur_accum & 255;
      if (a_count >= 254) {
        outStream.writeByte(a_count);
        outStream.writeBytesView(accum, 0, a_count);
        a_count = 0;
      }
      cur_accum >>= 8;
      cur_bits -= 8;
    }
    if (free_ent > maxcode || clear_flg) {
      if (clear_flg) {
        n_bits = g_init_bits;
        maxcode = (1 << n_bits) - 1;
        clear_flg = false;
      } else {
        ++n_bits;
        maxcode = n_bits === BITS ? 1 << n_bits : (1 << n_bits) - 1;
      }
    }
    if (code == EOFCode) {
      while (cur_bits > 0) {
        accum[a_count++] = cur_accum & 255;
        if (a_count >= 254) {
          outStream.writeByte(a_count);
          outStream.writeBytesView(accum, 0, a_count);
          a_count = 0;
        }
        cur_accum >>= 8;
        cur_bits -= 8;
      }
      if (a_count > 0) {
        outStream.writeByte(a_count);
        outStream.writeBytesView(accum, 0, a_count);
        a_count = 0;
      }
    }
  }
}
var lzwEncode_default = lzwEncode;

// src/rgb-packing.js
function rgb888_to_rgb565(r, g, b) {
  return r << 8 & 63488 | g << 2 & 992 | b >> 3;
}
function rgba8888_to_rgba4444(r, g, b, a) {
  return r >> 4 | g & 240 | (b & 240) << 4 | (a & 240) << 8;
}
function rgb888_to_rgb444(r, g, b) {
  return r >> 4 << 8 | g & 240 | b >> 4;
}

// src/pnnquant2.js
function clamp(value, min, max) {
  return value < min ? min : value > max ? max : value;
}
function sqr(value) {
  return value * value;
}
function find_nn(bins, idx, hasAlpha) {
  var nn = 0;
  var err = 1e100;
  const bin1 = bins[idx];
  const n1 = bin1.cnt;
  const wa = bin1.ac;
  const wr = bin1.rc;
  const wg = bin1.gc;
  const wb = bin1.bc;
  for (var i = bin1.fw; i != 0; i = bins[i].fw) {
    const bin = bins[i];
    const n2 = bin.cnt;
    const nerr2 = n1 * n2 / (n1 + n2);
    if (nerr2 >= err)
      continue;
    var nerr = 0;
    if (hasAlpha) {
      nerr += nerr2 * sqr(bin.ac - wa);
      if (nerr >= err)
        continue;
    }
    nerr += nerr2 * sqr(bin.rc - wr);
    if (nerr >= err)
      continue;
    nerr += nerr2 * sqr(bin.gc - wg);
    if (nerr >= err)
      continue;
    nerr += nerr2 * sqr(bin.bc - wb);
    if (nerr >= err)
      continue;
    err = nerr;
    nn = i;
  }
  bin1.err = err;
  bin1.nn = nn;
}
function create_bin() {
  return {
    ac: 0,
    rc: 0,
    gc: 0,
    bc: 0,
    cnt: 0,
    nn: 0,
    fw: 0,
    bk: 0,
    tm: 0,
    mtm: 0,
    err: 0
  };
}
function create_bin_list(data, format) {
  const bincount = format === "rgb444" ? 4096 : 65536;
  const bins = new Array(bincount);
  const size = data.length;
  if (format === "rgba4444") {
    for (let i = 0; i < size; ++i) {
      const color = data[i];
      const a = color >> 24 & 255;
      const b = color >> 16 & 255;
      const g = color >> 8 & 255;
      const r = color & 255;
      const index = rgba8888_to_rgba4444(r, g, b, a);
      let bin = index in bins ? bins[index] : bins[index] = create_bin();
      bin.rc += r;
      bin.gc += g;
      bin.bc += b;
      bin.ac += a;
      bin.cnt++;
    }
  } else if (format === "rgb444") {
    for (let i = 0; i < size; ++i) {
      const color = data[i];
      const b = color >> 16 & 255;
      const g = color >> 8 & 255;
      const r = color & 255;
      const index = rgb888_to_rgb444(r, g, b);
      let bin = index in bins ? bins[index] : bins[index] = create_bin();
      bin.rc += r;
      bin.gc += g;
      bin.bc += b;
      bin.cnt++;
    }
  } else {
    for (let i = 0; i < size; ++i) {
      const color = data[i];
      const b = color >> 16 & 255;
      const g = color >> 8 & 255;
      const r = color & 255;
      const index = rgb888_to_rgb565(r, g, b);
      let bin = index in bins ? bins[index] : bins[index] = create_bin();
      bin.rc += r;
      bin.gc += g;
      bin.bc += b;
      bin.cnt++;
    }
  }
  return bins;
}
function quantize(rgba, maxColors, opts = {}) {
  const {
    format = "rgb565",
    clearAlpha = true,
    clearAlphaColor = 0,
    clearAlphaThreshold = 0,
    oneBitAlpha = false
  } = opts;
  if (!rgba || !rgba.buffer) {
    throw new Error("quantize() expected RGBA Uint8Array data");
  }
  if (!(rgba instanceof Uint8Array) && !(rgba instanceof Uint8ClampedArray)) {
    throw new Error("quantize() expected RGBA Uint8Array data");
  }
  const data = new Uint32Array(rgba.buffer);
  let useSqrt = opts.useSqrt !== false;
  const hasAlpha = format === "rgba4444";
  const bins = create_bin_list(data, format);
  const bincount = bins.length;
  const bincountMinusOne = bincount - 1;
  const heap = new Uint32Array(bincount + 1);
  var maxbins = 0;
  for (var i = 0; i < bincount; ++i) {
    const bin = bins[i];
    if (bin != null) {
      var d = 1 / bin.cnt;
      if (hasAlpha)
        bin.ac *= d;
      bin.rc *= d;
      bin.gc *= d;
      bin.bc *= d;
      bins[maxbins++] = bin;
    }
  }
  if (sqr(maxColors) / maxbins < 0.022) {
    useSqrt = false;
  }
  var i = 0;
  for (; i < maxbins - 1; ++i) {
    bins[i].fw = i + 1;
    bins[i + 1].bk = i;
    if (useSqrt)
      bins[i].cnt = Math.sqrt(bins[i].cnt);
  }
  if (useSqrt)
    bins[i].cnt = Math.sqrt(bins[i].cnt);
  var h, l, l2;
  for (i = 0; i < maxbins; ++i) {
    find_nn(bins, i, false);
    var err = bins[i].err;
    for (l = ++heap[0]; l > 1; l = l2) {
      l2 = l >> 1;
      if (bins[h = heap[l2]].err <= err)
        break;
      heap[l] = h;
    }
    heap[l] = i;
  }
  var extbins = maxbins - maxColors;
  for (i = 0; i < extbins; ) {
    var tb;
    for (; ; ) {
      var b1 = heap[1];
      tb = bins[b1];
      if (tb.tm >= tb.mtm && bins[tb.nn].mtm <= tb.tm)
        break;
      if (tb.mtm == bincountMinusOne)
        b1 = heap[1] = heap[heap[0]--];
      else {
        find_nn(bins, b1, false);
        tb.tm = i;
      }
      var err = bins[b1].err;
      for (l = 1; (l2 = l + l) <= heap[0]; l = l2) {
        if (l2 < heap[0] && bins[heap[l2]].err > bins[heap[l2 + 1]].err)
          l2++;
        if (err <= bins[h = heap[l2]].err)
          break;
        heap[l] = h;
      }
      heap[l] = b1;
    }
    var nb = bins[tb.nn];
    var n1 = tb.cnt;
    var n2 = nb.cnt;
    var d = 1 / (n1 + n2);
    if (hasAlpha)
      tb.ac = d * (n1 * tb.ac + n2 * nb.ac);
    tb.rc = d * (n1 * tb.rc + n2 * nb.rc);
    tb.gc = d * (n1 * tb.gc + n2 * nb.gc);
    tb.bc = d * (n1 * tb.bc + n2 * nb.bc);
    tb.cnt += nb.cnt;
    tb.mtm = ++i;
    bins[nb.bk].fw = nb.fw;
    bins[nb.fw].bk = nb.bk;
    nb.mtm = bincountMinusOne;
  }
  let palette = [];
  var k = 0;
  for (i = 0; ; ++k) {
    let r = clamp(Math.round(bins[i].rc), 0, 255);
    let g = clamp(Math.round(bins[i].gc), 0, 255);
    let b = clamp(Math.round(bins[i].bc), 0, 255);
    let a = 255;
    if (hasAlpha) {
      a = clamp(Math.round(bins[i].ac), 0, 255);
      if (oneBitAlpha) {
        const threshold = typeof oneBitAlpha === "number" ? oneBitAlpha : 127;
        a = a <= threshold ? 0 : 255;
      }
      if (clearAlpha && a <= clearAlphaThreshold) {
        r = g = b = clearAlphaColor;
        a = 0;
      }
    }
    const color = hasAlpha ? [r, g, b, a] : [r, g, b];
    const exists = existsInPalette(palette, color);
    if (!exists)
      palette.push(color);
    if ((i = bins[i].fw) == 0)
      break;
  }
  return palette;
}
function existsInPalette(palette, color) {
  for (let i = 0; i < palette.length; i++) {
    const p = palette[i];
    let matchesRGB = p[0] === color[0] && p[1] === color[1] && p[2] === color[2];
    let matchesAlpha = p.length >= 4 && color.length >= 4 ? p[3] === color[3] : true;
    if (matchesRGB && matchesAlpha)
      return true;
  }
  return false;
}

// src/color.js
function euclideanDistanceSquared(a, b) {
  var sum = 0;
  var n;
  for (n = 0; n < a.length; n++) {
    const dx = a[n] - b[n];
    sum += dx * dx;
  }
  return sum;
}

// src/palettize.js
function roundStep(byte, step) {
  return step > 1 ? Math.round(byte / step) * step : byte;
}
function prequantize(rgba, {roundRGB = 5, roundAlpha = 10, oneBitAlpha = null} = {}) {
  const data = new Uint32Array(rgba.buffer);
  for (let i = 0; i < data.length; i++) {
    const color = data[i];
    let a = color >> 24 & 255;
    let b = color >> 16 & 255;
    let g = color >> 8 & 255;
    let r = color & 255;
    a = roundStep(a, roundAlpha);
    if (oneBitAlpha) {
      const threshold = typeof oneBitAlpha === "number" ? oneBitAlpha : 127;
      a = a <= threshold ? 0 : 255;
    }
    r = roundStep(r, roundRGB);
    g = roundStep(g, roundRGB);
    b = roundStep(b, roundRGB);
    data[i] = a << 24 | b << 16 | g << 8 | r << 0;
  }
}
function applyPalette(rgba, palette, format = "rgb565") {
  if (!rgba || !rgba.buffer) {
    throw new Error("quantize() expected RGBA Uint8Array data");
  }
  if (!(rgba instanceof Uint8Array) && !(rgba instanceof Uint8ClampedArray)) {
    throw new Error("quantize() expected RGBA Uint8Array data");
  }
  if (palette.length > 256) {
    throw new Error("applyPalette() only works with 256 colors or less");
  }
  const data = new Uint32Array(rgba.buffer);
  const length = data.length;
  const bincount = format === "rgb444" ? 4096 : 65536;
  const index = new Uint8Array(length);
  const cache = new Array(bincount);
  const hasAlpha = format === "rgba4444";
  if (format === "rgba4444") {
    for (let i = 0; i < length; i++) {
      const color = data[i];
      const a = color >> 24 & 255;
      const b = color >> 16 & 255;
      const g = color >> 8 & 255;
      const r = color & 255;
      const key = rgba8888_to_rgba4444(r, g, b, a);
      const idx = key in cache ? cache[key] : cache[key] = nearestColorIndexRGBA(r, g, b, a, palette);
      index[i] = idx;
    }
  } else {
    const rgb888_to_key = format === "rgb444" ? rgb888_to_rgb444 : rgb888_to_rgb565;
    for (let i = 0; i < length; i++) {
      const color = data[i];
      const b = color >> 16 & 255;
      const g = color >> 8 & 255;
      const r = color & 255;
      const key = rgb888_to_key(r, g, b);
      const idx = key in cache ? cache[key] : cache[key] = nearestColorIndexRGB(r, g, b, palette);
      index[i] = idx;
    }
  }
  return index;
}
function nearestColorIndexRGBA(r, g, b, a, palette) {
  let k = 0;
  let mindist = 1e100;
  for (let i = 0; i < palette.length; i++) {
    const px2 = palette[i];
    const a2 = px2[3];
    let curdist = sqr2(a2 - a);
    if (curdist > mindist)
      continue;
    const r2 = px2[0];
    curdist += sqr2(r2 - r);
    if (curdist > mindist)
      continue;
    const g2 = px2[1];
    curdist += sqr2(g2 - g);
    if (curdist > mindist)
      continue;
    const b2 = px2[2];
    curdist += sqr2(b2 - b);
    if (curdist > mindist)
      continue;
    mindist = curdist;
    k = i;
  }
  return k;
}
function nearestColorIndexRGB(r, g, b, palette) {
  let k = 0;
  let mindist = 1e100;
  for (let i = 0; i < palette.length; i++) {
    const px2 = palette[i];
    const r2 = px2[0];
    let curdist = sqr2(r2 - r);
    if (curdist > mindist)
      continue;
    const g2 = px2[1];
    curdist += sqr2(g2 - g);
    if (curdist > mindist)
      continue;
    const b2 = px2[2];
    curdist += sqr2(b2 - b);
    if (curdist > mindist)
      continue;
    mindist = curdist;
    k = i;
  }
  return k;
}
function snapColorsToPalette(palette, knownColors, threshold = 5) {
  if (!palette.length || !knownColors.length)
    return;
  const paletteRGB = palette.map((p) => p.slice(0, 3));
  const thresholdSq = threshold * threshold;
  const dim = palette[0].length;
  for (let i = 0; i < knownColors.length; i++) {
    let color = knownColors[i];
    if (color.length < dim) {
      color = [color[0], color[1], color[2], 255];
    } else if (color.length > dim) {
      color = color.slice(0, 3);
    } else {
      color = color.slice();
    }
    const r = nearestColorIndexWithDistance(paletteRGB, color.slice(0, 3), euclideanDistanceSquared);
    const idx = r[0];
    const distanceSq = r[1];
    if (distanceSq > 0 && distanceSq <= thresholdSq) {
      palette[idx] = color;
    }
  }
}
function sqr2(a) {
  return a * a;
}
function nearestColorIndex(colors, pixel, distanceFn = euclideanDistanceSquared) {
  let minDist = Infinity;
  let minDistIndex = -1;
  for (let j = 0; j < colors.length; j++) {
    const paletteColor = colors[j];
    const dist = distanceFn(pixel, paletteColor);
    if (dist < minDist) {
      minDist = dist;
      minDistIndex = j;
    }
  }
  return minDistIndex;
}
function nearestColorIndexWithDistance(colors, pixel, distanceFn = euclideanDistanceSquared) {
  let minDist = Infinity;
  let minDistIndex = -1;
  for (let j = 0; j < colors.length; j++) {
    const paletteColor = colors[j];
    const dist = distanceFn(pixel, paletteColor);
    if (dist < minDist) {
      minDist = dist;
      minDistIndex = j;
    }
  }
  return [minDistIndex, minDist];
}
function nearestColor(colors, pixel, distanceFn = euclideanDistanceSquared) {
  return colors[nearestColorIndex(colors, pixel, distanceFn)];
}

// src/index.js
function GIFEncoder(opt = {}) {
  const {initialCapacity = 4096, auto = true} = opt;
  const stream = createStream(initialCapacity);
  const HSIZE = 5003;
  const accum = new Uint8Array(256);
  const htab = new Int32Array(HSIZE);
  const codetab = new Int32Array(HSIZE);
  let hasInit = false;
  return {
    reset() {
      stream.reset();
      hasInit = false;
    },
    finish() {
      stream.writeByte(constants_default.trailer);
    },
    bytes() {
      return stream.bytes();
    },
    bytesView() {
      return stream.bytesView();
    },
    get buffer() {
      return stream.buffer;
    },
    get stream() {
      return stream;
    },
    writeHeader,
    writeFrame(index, width, height, opts = {}) {
      const {
        transparent = false,
        transparentIndex = 0,
        delay = 0,
        palette = null,
        repeat = 0,
        colorDepth = 8,
        dispose = -1
      } = opts;
      let first = false;
      if (auto) {
        if (!hasInit) {
          first = true;
          writeHeader();
          hasInit = true;
        }
      } else {
        first = Boolean(opts.first);
      }
      width = Math.max(0, Math.floor(width));
      height = Math.max(0, Math.floor(height));
      if (first) {
        if (!palette) {
          throw new Error("First frame must include a { palette } option");
        }
        encodeLogicalScreenDescriptor(stream, width, height, palette, colorDepth);
        encodeColorTable(stream, palette);
        if (repeat >= 0) {
          encodeNetscapeExt(stream, repeat);
        }
      }
      const delayTime = Math.round(delay / 10);
      encodeGraphicControlExt(stream, dispose, delayTime, transparent, transparentIndex);
      const useLocalColorTable = Boolean(palette) && !first;
      encodeImageDescriptor(stream, width, height, useLocalColorTable ? palette : null);
      if (useLocalColorTable)
        encodeColorTable(stream, palette);
      encodePixels(stream, index, width, height, colorDepth, accum, htab, codetab);
    }
  };
  function writeHeader() {
    writeUTFBytes(stream, "GIF89a");
  }
}
function encodeGraphicControlExt(stream, dispose, delay, transparent, transparentIndex) {
  stream.writeByte(33);
  stream.writeByte(249);
  stream.writeByte(4);
  if (transparentIndex < 0) {
    transparentIndex = 0;
    transparent = false;
  }
  var transp, disp;
  if (!transparent) {
    transp = 0;
    disp = 0;
  } else {
    transp = 1;
    disp = 2;
  }
  if (dispose >= 0) {
    disp = dispose & 7;
  }
  disp <<= 2;
  const userInput = 0;
  stream.writeByte(0 | disp | userInput | transp);
  writeUInt16(stream, delay);
  stream.writeByte(transparentIndex || 0);
  stream.writeByte(0);
}
function encodeLogicalScreenDescriptor(stream, width, height, palette, colorDepth = 8) {
  const globalColorTableFlag = 1;
  const sortFlag = 0;
  const globalColorTableSize = colorTableSize(palette.length) - 1;
  const fields = globalColorTableFlag << 7 | colorDepth - 1 << 4 | sortFlag << 3 | globalColorTableSize;
  const backgroundColorIndex = 0;
  const pixelAspectRatio = 0;
  writeUInt16(stream, width);
  writeUInt16(stream, height);
  stream.writeBytes([fields, backgroundColorIndex, pixelAspectRatio]);
}
function encodeNetscapeExt(stream, repeat) {
  stream.writeByte(33);
  stream.writeByte(255);
  stream.writeByte(11);
  writeUTFBytes(stream, "NETSCAPE2.0");
  stream.writeByte(3);
  stream.writeByte(1);
  writeUInt16(stream, repeat);
  stream.writeByte(0);
}
function encodeColorTable(stream, palette) {
  const colorTableLength = 1 << colorTableSize(palette.length);
  for (let i = 0; i < colorTableLength; i++) {
    let color = [0, 0, 0];
    if (i < palette.length) {
      color = palette[i];
    }
    stream.writeByte(color[0]);
    stream.writeByte(color[1]);
    stream.writeByte(color[2]);
  }
}
function encodeImageDescriptor(stream, width, height, localPalette) {
  stream.writeByte(44);
  writeUInt16(stream, 0);
  writeUInt16(stream, 0);
  writeUInt16(stream, width);
  writeUInt16(stream, height);
  if (localPalette) {
    const interlace = 0;
    const sorted = 0;
    const palSize = colorTableSize(localPalette.length) - 1;
    stream.writeByte(128 | interlace | sorted | 0 | palSize);
  } else {
    stream.writeByte(0);
  }
}
function encodePixels(stream, index, width, height, colorDepth = 8, accum, htab, codetab) {
  lzwEncode_default(width, height, index, colorDepth, stream, accum, htab, codetab);
}
function writeUInt16(stream, short) {
  stream.writeByte(short & 255);
  stream.writeByte(short >> 8 & 255);
}
function writeUTFBytes(stream, text) {
  for (var i = 0; i < text.length; i++) {
    stream.writeByte(text.charCodeAt(i));
  }
}
function colorTableSize(length) {
  return Math.max(Math.ceil(Math.log2(length)), 1);
}
var src_default = GIFEncoder;
//# sourceMappingURL=gifenc.js.map

return module.exports;})();

const {GIFEncoder, quantize, applyPalette} = window.gifenc;
const SCENE_OFF = "https://cdn.shopify.com/s/files/1/0576/4510/5175/files/CAT03-1.jpg?v=1782192448";
const SCENE_ON = "https://cdn.shopify.com/s/files/1/0576/4510/5175/files/CAT03-2.jpg?v=1782192448"
const QUAD_OFF=[[0,0],[1,0],[1,1],[0,1]];
const QUAD_ON =[[0,0],[1,0],[1,1],[0,1]];

const S={
  scenes:{off:{img:null,w:1000,h:1000,quad:QUAD_OFF.map(p=>p.slice())},
          on :{img:null,w:1000,h:1000,quad:QUAD_ON .map(p=>p.slice())}},
  art:{off:null,on:null},
  settings:{accent:'#7c5cff',wm:true,density:1,bloom:0.7,res:0,auto:true,gifw:460,sync:true},
  result:{off:null,on:null,offURL:null,onURL:null}
};
const $=id=>document.getElementById(id);
let _pvTimers=[];
function gstat(m,k){const s=$('status');s.textContent=m;s.className='mini '+(k||'');}
function setStat(el,m,k){if(el){el.textContent=m;el.className='st '+(k||'');}}
window.addEventListener('error',e=>gstat('Error: '+(e.message||'Unknown'),'err'));

/* ---------- math ---------- */
function solve(A,b){const n=b.length;for(let i=0;i<n;i++){let p=i;for(let r=i+1;r<n;r++)if(Math.abs(A[r][i])>Math.abs(A[p][i]))p=r;[A[i],A[p]]=[A[p],A[i]];[b[i],b[p]]=[b[p],b[i]];const d=A[i][i];for(let c=i;c<n;c++)A[i][c]/=d;b[i]/=d;for(let r=0;r<n;r++){if(r===i)continue;const f=A[r][i];for(let c=i;c<n;c++)A[r][c]-=f*A[i][c];b[r]-=f*b[i];}}return b;}
function homography(src,dst){const A=[],B=[];for(let i=0;i<4;i++){const[x,y]=src[i],[u,v]=dst[i];A.push([x,y,1,0,0,0,-x*u,-y*u]);B.push(u);A.push([0,0,0,x,y,1,-x*v,-y*v]);B.push(v);}const h=solve(A,B);return[[h[0],h[1],h[2]],[h[3],h[4],h[5]],[h[6],h[7],1]];}
function inv3(m){const[a,b,c]=m[0],[d,e,f]=m[1],[g,h,i]=m[2];const A=e*i-f*h,B=-(d*i-f*g),C=d*h-e*g;const det=a*A+b*B+c*C;return[[A/det,(-(b*i-c*h))/det,(b*f-c*e)/det],[B/det,(a*i-c*g)/det,(-(a*f-c*d))/det],[C/det,(-(a*h-b*g))/det,(a*e-b*d)/det]];}

/* ---------- image loading ---------- */
async function loadImage(file){
  if(window.createImageBitmap){try{return await createImageBitmap(file,{imageOrientation:'from-image'});}catch(e){}try{return await createImageBitmap(file);}catch(e){}}
  return await new Promise((res,rej)=>{const i=new Image();i.onload=()=>res(i);i.onerror=()=>rej(new Error('Cannot decode image (may be HEIC — please convert to JPG/PNG)'));i.src=URL.createObjectURL(file);});
}
function dims(im){return[im.width||im.naturalWidth,im.height||im.naturalHeight];}
// keep crossOrigin so the canvas stays exportable; do NOT retry without it (that taints the canvas and silently breaks all exports)
function srcToImg(src){return new Promise((res,rej)=>{const i=new Image();i.crossOrigin='anonymous';i.onload=()=>res(i);i.onerror=()=>rej(new Error('Scene image failed to load — CDN image must allow cross-origin (CORS)'));i.src=src;});}
// downscale any drawable to <=maxW, return {img(dataURL Image), w, h}
async function normalizeScene(drawable){
  let[w,h]=dims(drawable);const maxW=1100;const s=Math.min(1,maxW/w);
  const c=document.createElement('canvas');c.width=Math.round(w*s);c.height=Math.round(h*s);
  c.getContext('2d').drawImage(drawable,0,0,c.width,c.height);
  const img=await srcToImg(c.toDataURL('image/jpeg',0.9));
  return{img,w:c.width,h:c.height};
}

/* ---------- auto frame detection ---------- */
function autoDetectFrame(side){
  var sc=S.scenes[side],W=sc.w,H=sc.h;
  var cv=document.createElement('canvas');cv.width=W;cv.height=H;
  var ctx=cv.getContext('2d');ctx.drawImage(sc.img,0,0,W,H);
  var data=ctx.getImageData(0,0,W,H).data;
  var bright=function(x,y){var i=((y|0)*W+(x|0))*4;return data[i]*0.299+data[i+1]*0.587+data[i+2]*0.114;};
  var midX=W>>1,midY=H>>1;
  // walk OUTWARD from inside the art until brightness shifts and STAYS shifted = art→frame inner edge.
  // (sustained check over +5px ignores single-pixel art detail; scanning from center finds the INNER edge, not the outer frame/wall edge)
  function scanOut(fx,fy,dx,dy,limit){
    var base=bright(fx,fy);
    for(var s=3;s<limit;s++){
      var nx=Math.min(s+5,limit-1);
      if(Math.abs(bright(fx+dx*s,fy+dy*s)-base)>22 && Math.abs(bright(fx+dx*nx,fy+dy*nx)-base)>22) return s;
    }
    return limit;
  }
  function med(a){a.sort(function(p,q){return p-q;});return a[a.length>>1];}
  var N=9,Ls=[],Rs=[],Ts=[],Bs=[],i;
  for(i=0;i<N;i++){                                    // horizontal scans: left & right inner edges
    var y=midY+Math.round(((i/(N-1))-0.5)*H*0.4);
    Ls.push(midX-scanOut(midX,y,-1,0,midX-2));
    Rs.push(midX+scanOut(midX,y, 1,0,W-midX-2));
  }
  for(i=0;i<N;i++){                                    // vertical scans: top & bottom inner edges
    var x=midX+Math.round(((i/(N-1))-0.5)*W*0.4);
    Ts.push(midY-scanOut(x,midY,0,-1,midY-2));
    Bs.push(midY+scanOut(x,midY,0, 1,H-midY-2));
  }
  var L=med(Ls),R=med(Rs),T=med(Ts),B=med(Bs);
  if(R-L>W*0.15 && B-T>H*0.15 && L>2 && T>2 && R<W-2 && B<H-2){
    sc.quad=[[L,T],[R,T],[R,B],[L,B]];
  }else{
    var ix=W*0.12,iy=H*0.10;sc.quad=[[ix,iy],[W-ix,iy],[W-ix,H-iy],[ix,H-iy]];
  }
  if(sc._upd)sc._upd();
  S.result[side]=null;compose(side);refresh();
}

/* ---------- editor (corner handles) ---------- */
function buildEditor(side){
  const sc=S.scenes[side], host=$(side==='off'?'edOff':'edOn');
  host.innerHTML='';
  const img=document.createElement('img');img.src=sc.img.src;host.appendChild(img);
  const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
  svg.setAttribute('viewBox','0 0 '+sc.w+' '+sc.h);svg.setAttribute('preserveAspectRatio','none');
  const poly=document.createElementNS('http://www.w3.org/2000/svg','polygon');
  poly.setAttribute('fill','rgba(124,92,255,0.12)');poly.setAttribute('stroke','#7c5cff');poly.setAttribute('stroke-width','3');poly.setAttribute('pointer-events','none');
  svg.appendChild(poly);host.appendChild(svg);
  function upd(){poly.setAttribute('points',sc.quad.map(p=>p[0]+','+p[1]).join(' '));
    hs.forEach((hd,i)=>{hd.style.left=(sc.quad[i][0]/sc.w*100)+'%';hd.style.top=(sc.quad[i][1]/sc.h*100)+'%';});}
  const loupe=document.createElement('div');loupe.className='sc-loupe';host.appendChild(loupe);
  const M=2.6,Ls=120;
  // magnify the area around corner idx so the finger/cursor doesn't hide the frame corner
  function showLoupe(idx,r){
    const px=sc.quad[idx][0]/sc.w*r.width, py=sc.quad[idx][1]/sc.h*r.height;
    loupe.style.backgroundImage='url("'+sc.img.src+'")';
    loupe.style.backgroundSize=(r.width*M)+'px '+(r.height*M)+'px';
    loupe.style.backgroundPosition=(Ls/2-px*M)+'px '+(Ls/2-py*M)+'px';
    let top=py-Ls-22; if(top<2)top=py+22;                 // sit above the point (above finger); flip below near the top
    top=Math.max(2,Math.min(Math.max(2,r.height-Ls-2),top));
    const left=Math.max(2,Math.min(Math.max(2,r.width-Ls-2),px-Ls/2));
    loupe.style.left=left+'px';loupe.style.top=top+'px';loupe.classList.add('show');
  }
  const hs=[];
  for(let i=0;i<4;i++){
    const hd=document.createElement('div');hd.className='handle';host.appendChild(hd);hs.push(hd);
    let drag=false;
    const move=ev=>{if(!drag)return;ev.preventDefault();const r=host.getBoundingClientRect();
      const cx=(ev.touches?ev.touches[0].clientX:ev.clientX),cy=(ev.touches?ev.touches[0].clientY:ev.clientY);
      sc.quad[i][0]=Math.max(0,Math.min(sc.w,(cx-r.left)/r.width*sc.w));
      sc.quad[i][1]=Math.max(0,Math.min(sc.h,(cy-r.top)/r.height*sc.h));upd();showLoupe(i,r);
      if(S.settings.sync){const o=S.scenes[side==='off'?'on':'off'];o.quad[i][0]=sc.quad[i][0]/sc.w*o.w;o.quad[i][1]=sc.quad[i][1]/sc.h*o.h;if(o._upd)o._upd();}};
    const up=()=>{if(!drag)return;drag=false;loupe.classList.remove('show');document.removeEventListener('pointermove',move);document.removeEventListener('pointerup',up);compose(side);if(S.settings.sync){const os=side==='off'?'on':'off';S.result[os]=null;compose(os);}refresh();};
    hd.addEventListener('pointerdown',ev=>{ev.preventDefault();drag=true;showLoupe(i,host.getBoundingClientRect());document.addEventListener('pointermove',move);document.addEventListener('pointerup',up);});
  }
  sc._upd=upd;upd();
}

/* ---------- compositing ---------- */
function coverCrop(img,aspect){
  const[iw,ih]=dims(img);let sx=0,sy=0,sw=iw,sh=ih;const ar=iw/ih;
  if(ar>aspect){sw=ih*aspect;sx=(iw-sw)/2;}else{sh=iw/aspect;sy=(ih-sh)/2;}
  const cap=620,s=Math.min(1,cap/sw);const c=document.createElement('canvas');
  c.width=Math.max(2,Math.round(sw*s));c.height=Math.max(2,Math.round(sh*s));
  c.getContext('2d').drawImage(img,sx,sy,sw,sh,0,0,c.width,c.height);return c;
}
function watermark(ctx,W,H){
  const fs=Math.round(W*0.040);ctx.save();ctx.translate(W/2,H/2);ctx.rotate(30*Math.PI/180);
  ctx.font='bold '+fs+'px Arial, sans-serif';ctx.textAlign='left';ctx.textBaseline='top';
  ctx.fillStyle='rgba(255,255,255,0.28)';ctx.strokeStyle='rgba(0,0,0,0.16)';ctx.lineWidth=Math.max(1,fs/26);
  const tw=ctx.measureText('BASESUN').width,sx=tw*1.7/S.settings.density,sy=fs*2.6/S.settings.density,diag=Math.hypot(W,H);
  let row=0;for(let y=-diag;y<diag;y+=sy,row++){const ox=row%2?sx/2:0;for(let x=-diag-ox;x<diag;x+=sx){ctx.strokeText('BASESUN',x,y);ctx.fillText('BASESUN',x,y);}}
  ctx.restore();
}
// inner shadow with a top-left light direction: top & left lips full strength, right & bottom a faint
// fraction — so the art reads as seated inside the frame on all four sides without looking like a tunnel
function innerShadow(cv,strength){
  const ctx=cv.getContext('2d'),W=cv.width,H=cv.height,d=Math.max(2,Math.round(Math.min(W,H)*0.035));
  const band=(a,gx0,gy0,gx1,gy1,rx,ry,rw,rh)=>{const g=ctx.createLinearGradient(gx0,gy0,gx1,gy1);g.addColorStop(0,'rgba(0,0,0,'+a+')');g.addColorStop(1,'rgba(0,0,0,0)');ctx.fillStyle=g;ctx.fillRect(rx,ry,rw,rh);};
  const lite=+(strength*0.55).toFixed(3),d2=Math.max(2,Math.round(d*0.6)); // right/bottom: narrower band, a touch darker
  ctx.save();
  band(strength,0,0,0,d,     0,0,     W,d);    // top (light source)
  band(strength,0,0,d,0,     0,0,     d,H);    // left (light source)
  band(lite,    0,H,0,H-d2,  0,H-d2,  W,d2);   // bottom (faint, narrow)
  band(lite,    W,0,W-d2,0,  W-d2,0,  d2,H);   // right (faint, narrow)
  ctx.restore();
}
function quadAspect(q){const w=((q[1][0]-q[0][0])+(q[2][0]-q[3][0]))/2;const h=((q[3][1]-q[0][1])+(q[2][1]-q[1][1]))/2;return w/h;}
function compose(side){
  const sc=S.scenes[side],W=sc.w,H=sc.h;
  const C=document.createElement('canvas');C.width=W;C.height=H;const ctx=C.getContext('2d');
  ctx.drawImage(sc.img,0,0,W,H);
  const art=S.art[side];
  if(art){
    let acv=coverCrop(art,quadAspect(sc.quad));
    if(side==='on'){const t=document.createElement('canvas');t.width=acv.width;t.height=acv.height;const tx=t.getContext('2d');tx.filter='saturate(1.12) brightness(1.05)';tx.drawImage(acv,0,0);acv=t;}
    // Paper texture for lights-off (line art)
    if(side==='off'){const pc=document.createElement('canvas');pc.width=acv.width;pc.height=acv.height;const px=pc.getContext('2d');px.filter='contrast(0.92) brightness(1.04)';px.drawImage(acv,0,0);acv=pc;}
    innerShadow(acv,side==='on'?0.30:0.42); // frame-lip depth; lighter on the glowing side so bloom isn't crushed
    const aw=acv.width,ah=acv.height,aData=acv.getContext('2d').getImageData(0,0,aw,ah).data;
    const Hi=inv3(homography([[0,0],[aw,0],[aw,ah],[0,ah]],sc.quad));
    const layer=ctx.createImageData(W,H),ld=layer.data;
    const xs=sc.quad.map(p=>p[0]),ys=sc.quad.map(p=>p[1]);
    const x0=Math.max(0,Math.floor(Math.min.apply(0,xs))),x1=Math.min(W-1,Math.ceil(Math.max.apply(0,xs)));
    const y0=Math.max(0,Math.floor(Math.min.apply(0,ys))),y1=Math.min(H-1,Math.ceil(Math.max.apply(0,ys)));
    for(let y=y0;y<=y1;y++)for(let x=x0;x<=x1;x++){
      const w=Hi[2][0]*x+Hi[2][1]*y+Hi[2][2];
      const u=(Hi[0][0]*x+Hi[0][1]*y+Hi[0][2])/w,v=(Hi[1][0]*x+Hi[1][1]*y+Hi[1][2])/w;
      if(u<0||v<0||u>=aw-1||v>=ah-1)continue;
      const u0=u|0,v0=v|0,fu=u-u0,fv=v-v0,i00=(v0*aw+u0)*4,i10=i00+4,i01=i00+aw*4,i11=i01+4,o=(y*W+x)*4;
      for(let k=0;k<3;k++){const a=aData[i00+k]*(1-fu)+aData[i10+k]*fu,b=aData[i01+k]*(1-fu)+aData[i11+k]*fu;ld[o+k]=a*(1-fv)+b*fv;}
      ld[o+3]=255;
    }
    const lc=document.createElement('canvas');lc.width=W;lc.height=H;lc.getContext('2d').putImageData(layer,0,0);
    if(side==='on'){
      ctx.drawImage(lc,0,0);
      const bl=document.createElement('canvas');bl.width=W;bl.height=H;const bx=bl.getContext('2d');
      bx.filter='blur('+Math.round(W*0.012)+'px) brightness(1.5)';bx.drawImage(lc,0,0);
      ctx.globalCompositeOperation='screen';ctx.globalAlpha=S.settings.bloom;ctx.drawImage(bl,0,0);
      ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
    }else{ctx.globalAlpha=0.96;ctx.drawImage(lc,0,0);ctx.globalAlpha=1;}
  }
  if(S.settings.wm)watermark(ctx,W,H);
  S.result[side]=C;
  try{S.result[side+'URL']=C.toDataURL('image/jpeg',0.85);}catch(e){S.result[side+'URL']=SCENE_OFF;}
}

/* ---------- preview widget ---------- */
function renderPreview(){
  const sc=S.scenes.on;const wrap=$('previewWrap');wrap.innerHTML='';
  _pvTimers.forEach(t=>{clearTimeout(t);clearInterval(t);});_pvTimers=[]; // kill timers from any prior preview (refresh() rebuilds this on every slider input)
  const el=document.createElement('div');el.className='bsw-light';
  el.style.setProperty('--accent',S.settings.accent);el.style.setProperty('--res',S.settings.res);
  el.innerHTML='<div class="bsw-stage" tabindex="0"><img class="bsw-img bsw-on" src="'+S.result.onURL+'"><img class="bsw-img bsw-off" src="'+S.result.offURL+'"><div class="bsw-glow"></div><span class="bsw-hint">Tap to light up</span></div><div class="bsw-bar"><span class="bsw-label">Off</span><button class="bsw-switch"><span class="bsw-knob"></span></button><span class="bsw-label bsw-label-on">On</span></div>';
  const stage=el.querySelector('.bsw-stage');stage.style.aspectRatio=sc.w+'/'+sc.h;wrap.appendChild(el);
  let timer=null,touched=false;const set=o=>el.classList.toggle('is-on',o);const tg=()=>set(!el.classList.contains('is-on'));
  const stop=()=>{touched=true;if(timer){clearInterval(timer);timer=null;}};const onU=()=>{stop();tg();};
  stage.addEventListener('click',onU);el.querySelector('.bsw-switch').addEventListener('click',e=>{e.stopPropagation();onU();});
  if(S.settings.auto){_pvTimers.push(setTimeout(()=>{if(!touched)set(true);},700));timer=setInterval(()=>{if(!touched)tg();},3400);_pvTimers.push(timer);}
}
function widgetCode(){
  var sc=S.scenes.on,a=S.settings;
  var lines=[];
  lines.push('<div class="bsw-light" data-autoplay="'+(a.auto?'true':'false')+'" style="--bsw-accent:'+a.accent+';--bsw-radius:18px;--bsw-max:520px;--bsw-on-residual:'+a.res+'">');
  lines.push('  <div class="bsw-stage" role="button" tabindex="0">');
  lines.push('    <img class="bsw-img bsw-on" alt="BASESUN Custom Light Painting" src="'+S.result.onURL+'" draggable="false" oncontextmenu="return false">');
  lines.push('    <img class="bsw-img bsw-off" alt="BASESUN Custom Light Painting" src="'+S.result.offURL+'" draggable="false" oncontextmenu="return false">');
  lines.push('    <div class="bsw-glow"></div><div class="bsw-shield"></div><span class="bsw-hint">Tap to light up</span>');
  lines.push('  </div>');
  lines.push('  <div class="bsw-bar"><span class="bsw-label">Off</span><button class="bsw-switch" type="button"><span class="bsw-knob"></span></button><span class="bsw-label bsw-label-on">On</span></div>');
  lines.push('</div>');
  lines.push('<style>');
  lines.push('.bsw-light{max-width:var(--bsw-max);margin:0 auto;font-family:-apple-system,PingFang SC,Microsoft YaHei,sans-serif;-webkit-user-select:none;user-select:none}');
  lines.push('.bsw-stage{position:relative;width:100%;aspect-ratio:'+sc.w+'/'+sc.h+';border-radius:var(--bsw-radius);overflow:hidden;background:#111;cursor:pointer;box-shadow:0 8px 30px rgba(0,0,0,.18)}');
  lines.push('.bsw-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;-webkit-user-drag:none;pointer-events:none}');
  lines.push('.bsw-off{opacity:1;transition:opacity .6s}.bsw-light.is-on .bsw-off{opacity:var(--bsw-on-residual,0)}');
  lines.push('.bsw-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .6s;background:radial-gradient(120% 80% at 50% 35%,rgba(255,210,120,.18),transparent 60%);mix-blend-mode:screen}');
  lines.push('.bsw-shield{position:absolute;inset:0;background:transparent;z-index:5}.bsw-light.is-on .bsw-glow{opacity:1}');
  lines.push('.bsw-hint{position:absolute;left:50%;bottom:14px;transform:translateX(-50%);z-index:6;font-size:13px;color:#fff;background:rgba(0,0,0,.5);padding:6px 14px;border-radius:999px;transition:opacity .4s}.bsw-light.is-on .bsw-hint{opacity:0}');
  lines.push('.bsw-bar{display:flex;align-items:center;justify-content:center;gap:12px;margin-top:14px}.bsw-label{font-size:14px;color:#9aa0a6;font-weight:600}.bsw-light.is-on .bsw-label-on{color:var(--bsw-accent)}');
  lines.push('.bsw-switch{position:relative;width:58px;height:32px;border:none;border-radius:999px;background:#d2d5da;cursor:pointer;transition:.35s}.bsw-light.is-on .bsw-switch{background:var(--bsw-accent)}');
  lines.push('.bsw-knob{position:absolute;top:3px;left:3px;width:26px;height:26px;border-radius:50%;background:#fff;transition:transform .35s cubic-bezier(.4,1.3,.5,1)}.bsw-light.is-on .bsw-knob{transform:translateX(26px)}');
  lines.push('</style>');
  lines.push('<script>(function(){document.querySelectorAll(".bsw-light").forEach(function(w){var s=w.querySelector(".bsw-stage"),b=w.querySelector(".bsw-switch"),a=w.getAttribute("data-autoplay")==="true",t=null,u=false;function set(o){w.classList.toggle("is-on",o);}function tg(){set(!w.classList.contains("is-on"));}function st(){u=true;if(t){clearInterval(t);t=null;}}function on(){st();tg();}s.addEventListener("click",on);b.addEventListener("click",function(e){e.stopPropagation();on();});w.addEventListener("contextmenu",function(e){e.preventDefault();});w.addEventListener("dragstart",function(e){e.preventDefault();});if(a){setTimeout(function(){if(!u)set(true);},700);t=setInterval(function(){if(!u)tg();},3400);}});})();</scr'+'ipt>');
  return lines.join('\n');
}

// paint one transition frame EXACTLY like the on-page preview: lit image as base, the off image fading to the
// On-Residual amount on top, plus the ambient screen glow fading in. (export used to just crossfade off→on,
// so On-Residual and the glow overlay never showed up in the GIF/video.) t: 0 = off … 1 = on
function paintTransition(ctx,W,H,on,off,t){
  const res=S.settings.res;
  ctx.clearRect(0,0,W,H);
  ctx.globalAlpha=1;ctx.drawImage(on,0,0,W,H);                          // lit base (bloom already baked in)
  ctx.globalAlpha=Math.max(0,1-t*(1-res));ctx.drawImage(off,0,0,W,H);   // off fades 1 → res as it turns on
  ctx.globalAlpha=1;
  if(t>0){                                                              // ambient glow == .bsw-glow (screen blend)
    const g=ctx.createRadialGradient(W*0.5,H*0.35,0,W*0.5,H*0.35,Math.max(W,H)*0.7);
    g.addColorStop(0,'rgba(255,210,120,'+(0.18*t).toFixed(3)+')');g.addColorStop(0.6,'rgba(255,210,120,0)');
    ctx.globalCompositeOperation='screen';ctx.fillStyle=g;ctx.fillRect(0,0,W,H);ctx.globalCompositeOperation='source-over';
  }
}

/* ---------- GIF ---------- */
async function makeGif(){
  const off=S.result.off,on=S.result.on,ratio=off.height/off.width,W=S.settings.gifw,H=Math.round(W*ratio);
  const cv=document.createElement('canvas');cv.width=W;cv.height=H;const ctx=cv.getContext('2d');
  const draw=t=>{paintTransition(ctx,W,H,on,off,t);return ctx.getImageData(0,0,W,H).data;};
  // build the palette from BOTH the off (bright room, first thing viewers see) and on frames, so neither state bands/shifts color
  const f0=draw(0),f1=draw(1),comb=new Uint8Array(f0.length+f1.length);comb.set(f0,0);comb.set(f1,f0.length);
  const pal=quantize(comb,256);
  // Slow fade: off → ease-in → on → ease-out → off
  const seq=[
    [0,900],
    [0.05,120],[0.1,120],[0.16,120],[0.22,120],[0.28,120],[0.35,120],[0.42,120],
    [0.5,120],[0.58,120],[0.66,120],[0.74,120],[0.82,120],[0.9,120],[0.96,120],
    [1,3000],
    [0.92,120],[0.84,120],[0.76,120],[0.68,120],[0.6,120],[0.5,120],
    [0.4,120],[0.3,120],[0.2,120],[0.12,120],[0.05,120],
    [0,700]
  ];
  const gif=GIFEncoder();
  for(let i=0;i<seq.length;i++){const idx=applyPalette(draw(seq[i][0]),pal);gif.writeFrame(idx,W,H,{palette:pal,delay:seq[i][1],repeat:i===0?0:undefined});await new Promise(r=>setTimeout(r));}
  gif.finish();return new Blob([gif.bytes()],{type:'image/gif'});
}

/* ---------- Video ---------- */
async function makeVideo(){
  const off=S.result.off,on=S.result.on,ratio=off.height/off.width;
  // video resolution capped 720px (smaller so fine detail/artifacts read softer); file size isn't a concern, so bitrate stays high → still clean
  let W=Math.min(720,off.width||640);W-=W%2;let H=Math.round(W*ratio);H-=H%2;
  const cv=document.createElement('canvas');cv.width=W;cv.height=H;const ctx=cv.getContext('2d');
  const draw=t=>paintTransition(ctx,W,H,on,off,t);
  const fps=30;const stream=cv.captureStream(fps);
  // prefer MP4 (plays on iOS/Safari, accepted by Shopify product video + Instagram/TikTok); fall back to webm where MP4 recording is unsupported
  const cands=['video/mp4;codecs=h264','video/mp4','video/webm;codecs=vp9','video/webm;codecs=vp8','video/webm'];
  const mime=cands.find(t=>window.MediaRecorder&&MediaRecorder.isTypeSupported(t))||'video/webm';
  const baseType=mime.split(';')[0];
  const bitrate=Math.min(16000000,Math.max(6000000,Math.round(W*H*fps*0.2)));
  const recorder=new MediaRecorder(stream,{mimeType:mime,videoBitsPerSecond:bitrate});
  const chunks=[];
  recorder.ondataavailable=e=>chunks.push(e.data);
  const done=new Promise(res=>{recorder.onstop=()=>res(new Blob(chunks,{type:baseType}));});
  // Timeline: off(0.5s) → fade-up(2s, ease-in) → on(3s) → fade-down(2s, ease-out) → off(0.5s) = 8s
  const fadeUpStart=0.5, fadeUpEnd=2.5, onEnd=5.5, fadeDownEnd=7.5, totalDur=8;
  const totalFrames=Math.ceil(totalDur*fps);
  var t=0,frame=0;
  recorder.start();
  return new Promise(async res=>{
    var step=()=>{
      if(frame>=totalFrames){recorder.stop();done.then(b=>res(b));return;}
      var sec=frame/fps, alpha=0;
      if(sec<fadeUpStart) alpha=0;
      else if(sec<fadeUpEnd){var p=(sec-fadeUpStart)/(fadeUpEnd-fadeUpStart);alpha=p*p*(3-2*p);}          // ease-in-out
      else if(sec<onEnd) alpha=1;
      else if(sec<fadeDownEnd){var p2=(sec-onEnd)/(fadeDownEnd-onEnd);alpha=1-p2*p2*(3-2*p2);}              // ease-in-out reversed
      else alpha=0;
      draw(alpha);
      frame++;
      requestAnimationFrame(step);
    };
    step();
  });
}


/* ---------- refresh ---------- */
function refresh(){
  try{
    if(!S.result.off)compose('off');
    if(!S.result.on)compose('on');
    renderPreview();
    $('codeOut').value=widgetCode();
    const ready=S.art.off&&S.art.on;
    ['btnCode','btnGif','btnVideo','btnEmail','btnImgOff','btnImgOn'].forEach(id=>$(id).disabled=!ready);
    gstat(ready?'✓ Ready':'Add both artwork images to export','ok');
  }catch(err){gstat('Generation failed: '+err.message,'err');}
}

/* ---------- wiring ---------- */
function bindArt(dropId,fileId,statId,key,zh){
  const drop=$(dropId),file=$(fileId),st=$(statId);
  drop.addEventListener('click',e=>{if(e.target!==file)file.click();});
  ['dragover','dragenter'].forEach(e=>drop.addEventListener(e,ev=>{ev.preventDefault();drop.classList.add('over');}));
  ['dragleave','drop'].forEach(e=>drop.addEventListener(e,ev=>{ev.preventDefault();drop.classList.remove('over');}));
  drop.addEventListener('drop',ev=>{const f=ev.dataTransfer.files[0];if(f)go(f);});
  file.addEventListener('change',ev=>{const f=ev.target.files[0];if(f)go(f);});
  async function go(f){try{setStat(st,'Loading…');const img=await loadImage(f);S.art[key]=img;const[w,h]=dims(img);
    drop.querySelector('img.thumb')?.remove();const t=new Image();t.className='thumb';
    t.src=(img instanceof ImageBitmap)?(()=>{const c=document.createElement('canvas');c.width=img.width;c.height=img.height;c.getContext('2d').drawImage(img,0,0);return c.toDataURL('image/jpeg',0.8);})():img.src;
    drop.appendChild(t);setStat(st,'✓ Loaded '+w+'×'+h,'ok');compose(key);refresh();
  }catch(err){setStat(st,'✗ '+err.message,'err');}}
}
function bindScene(fileId,side){
  $(fileId).addEventListener('change',async ev=>{const f=ev.target.files[0];if(!f)return;
    try{const im=await loadImage(f);const n=await normalizeScene(im);S.scenes[side].img=n.img;S.scenes[side].w=n.w;S.scenes[side].h=n.h;
      // reset quad to 12% inset rectangle for re-calibration
      const ix=n.w*0.12,iy=n.h*0.10;S.scenes[side].quad=[[ix,iy],[n.w-ix,iy],[n.w-ix,n.h-iy],[ix,n.h-iy]];
      S.result[side]=null;buildEditor(side);compose(side);refresh();gstat('Replaced '+(side==='off'?'Lights Off':'Lights On')+' scene — drag corners to align frame','');
    }catch(err){gstat('Scene image load failed: '+err.message,'err');}});
}
function download(u,name){const a=document.createElement('a');a.href=(typeof u==='string')?u:URL.createObjectURL(u);a.download=name;a.click();if(typeof u!=='string')setTimeout(()=>URL.revokeObjectURL(a.href),2000);}

$('accent').addEventListener('input',e=>{S.settings.accent=e.target.value;document.documentElement.style.setProperty('--accent',e.target.value);refresh();});
$('density').addEventListener('input',e=>{S.settings.density=+e.target.value;S.result.off=S.result.on=null;refresh();});
$('bloom').addEventListener('input',e=>{S.settings.bloom=+e.target.value;S.result.on=null;refresh();});
$('res').addEventListener('input',e=>{S.settings.res=+e.target.value;renderPreview();$('codeOut').value=widgetCode();});
$('gifw').addEventListener('change',e=>{S.settings.gifw=+e.target.value;});
$('wmT').addEventListener('click',()=>{S.settings.wm=!S.settings.wm;$('wmT').classList.toggle('on',S.settings.wm);S.result.off=S.result.on=null;refresh();});
$('autoT').addEventListener('click',()=>{S.settings.auto=!S.settings.auto;$('autoT').classList.toggle('on',S.settings.auto);renderPreview();$('codeOut').value=widgetCode();});
$('syncT').addEventListener('click',()=>{S.settings.sync=!S.settings.sync;$('syncT').classList.toggle('on',S.settings.sync);
  if(S.settings.sync){const f=S.scenes.off,o=S.scenes.on;for(let i=0;i<4;i++){o.quad[i][0]=f.quad[i][0]/f.w*o.w;o.quad[i][1]=f.quad[i][1]/f.h*o.h;}if(o._upd)o._upd();S.result.on=null;compose('on');refresh();gstat('Synced: light-on corners aligned to light-off','ok');}});
$('btnAutoFrame').addEventListener('click',()=>{gstat('Auto-detecting frame edges…');try{autoDetectFrame('off');if(S.settings.sync)autoDetectFrame('on');gstat('Auto-detected! Fine-tune by dragging corners if needed','ok');}catch(e){gstat('Auto-detect failed: '+e.message,'err');}});
$('btnEmail').addEventListener('click',()=>{var orderLink=$('orderLink').value.trim()||'https://basesuntech.com/products/custom-led-light-up-painting-frame-personalized-art-glowing-frame';var text='Want your own custom light painting?\\n\\n'+orderLink+'\\n\\n✨ Free worldwide shipping\\n\\n— BASESUN';navigator.clipboard.writeText(text).then(()=>gstat('✓ Email text copied! 1. Drag GIF into Gmail 2. Paste this text below','ok')).catch(e=>gstat('Copy failed: '+e.message,'err'));});
$('btnCode').addEventListener('click',()=>navigator.clipboard.writeText($('codeOut').value).then(()=>gstat('✓ Site code copied','ok')));
$('btnGif').addEventListener('click',async()=>{gstat('Generating GIF…');$('btnGif').disabled=true;try{const b=await makeGif();download(b,'BASESUN_light_switch.gif');gstat('✓ GIF downloaded '+Math.round(b.size/1024)+'KB','ok');}catch(e){gstat('GIF failed: '+e.message,'err');}$('btnGif').disabled=false;});
$('btnVideo').addEventListener('click',async()=>{gstat('Recording video…');$('btnVideo').disabled=true;try{const b=await makeVideo();const ext=b.type.indexOf('mp4')>=0?'mp4':'webm';download(b,'BASESUN_light_switch.'+ext);gstat('✓ Video ('+ext.toUpperCase()+') downloaded '+Math.round(b.size/1024)+'KB','ok');}catch(e){gstat('Video failed: '+e.message,'err');}$('btnVideo').disabled=false;});
$('btnImgOff').addEventListener('click',()=>{try{download(S.result.off.toDataURL('image/jpeg',0.92),'BASESUN_light_off.jpg');}catch(e){gstat('Export failed: tainted canvas — refresh page','err');}});
$('btnImgOn').addEventListener('click',()=>{try{download(S.result.on.toDataURL('image/jpeg',0.92),'BASESUN_light_on.jpg');}catch(e){gstat('Export failed: tainted canvas — refresh page','err');}});
bindArt('dropOff','artOff','stOff','off','Line Art');
bindArt('dropOn','artOn','stOn','on','Color Art');
bindScene('sceneOff','off');bindScene('sceneOn','on');
$('btnToggleCode').addEventListener('click',()=>{const ta=$('codeOut'),btn=$('btnToggleCode');if(ta.style.display==='none'){ta.style.display='block';btn.textContent='Hide Site Code';}else{ta.style.display='none';btn.textContent='Show Site Code';}});

/* ---------- init ---------- */
(async function(){
  try{
    S.scenes.off.img=await srcToImg(SCENE_OFF);
    S.scenes.on.img =await srcToImg(SCENE_ON);
    const[ow,oh]=dims(S.scenes.off.img),[tw,th]=dims(S.scenes.on.img);
    S.scenes.off.w=ow;S.scenes.off.h=oh;S.scenes.on.w=tw;S.scenes.on.h=th;
    const oix=ow*0.12,oiy=oh*0.10,tix=tw*0.12,tiy=th*0.10;
    S.scenes.off.quad=[[oix,oiy],[ow-oix,oiy],[ow-oix,oh-oiy],[oix,oh-oiy]];
    S.scenes.on.quad =[[tix,tiy],[tw-tix,tiy],[tw-tix,th-tiy],[tix,th-tiy]];
    buildEditor('off');buildEditor('on');
    compose('off');compose('on');refresh();
    gstat('Default scene ready — drag the purple corners to align with your frame edges, then add artwork','');
  }catch(e){gstat('Init error: '+e.message,'err');}
})();
